import React from "react";
import { Navigate } from "react-router-dom";
import PathConstants from "./path-constants";

const CoverageFundEligibilityPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-eligibility"),
);
const MedicationConditionEligibilityPage = React.lazy(
  () => import("../pages/product/eligibility/medication-condition-eligibility"),
);
const CoverageFundQualifyPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-qualify"),
);
const CoverageFundNotQualifyPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-not-qualify"),
);

const routes = [
  {
    path: PathConstants.Root,
    element: <Navigate to={PathConstants.MedicationConditionEligibility} />,
  },
  {
    path: PathConstants.CoverageFundEligibility,
    element: <CoverageFundEligibilityPage />,
  },
  {
    path: PathConstants.MedicationConditionEligibility,
    element: <MedicationConditionEligibilityPage />,
  },
  {
    path: PathConstants.CoverageFundQualify,
    element: <CoverageFundQualifyPage />,
  },
  {
    path: PathConstants.CoverageFundNotQualify,
    element: <CoverageFundNotQualifyPage />,
  },
];

export default routes;
